import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {VehicleType} from "../../../commons/types/vehicle.type";

export class vehicleTypeSelectCtrl implements IController {

  form: any;
  types: any;
  selected: any;
  required: any;
  onChange: Function;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    if (!this.types || !this.types.length) {
      this.types = Object.values(VehicleType);
    }
  }

  onVehicleSelect(vehicle) {
    if (_.isFunction(this.onChange)) {
      this.onChange({vehicleType: vehicle});
    }
  }

}

angular
  .module('bringoz.admin.vehicles')
  .component('vehicleTypeSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      types: '<?',
      selected: '=',
      required: '@?',
      onChange: '&'
    },
    template: require('./vehicle-type-select.html').default,
    controller: vehicleTypeSelectCtrl
  });
